// The "Meet Latently" section — our own shipped product, called out as the
// one live thing on the page. Mounted by Landing.tsx between WhatWeDo and
// HowWeWork. Copy is verbatim from the pre-overhaul Landing.tsx.
import { MintNest } from '../marks/MintNest';
import { RoomWindow } from '../RoomWindow';
import './MeetLatently.css';

const Arrow = () => (
  <svg className="arrow" width="14" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M1 5h11M8.5 1.5 12 5l-3.5 3.5" />
  </svg>
);

export function MeetLatently() {
  return (
    <section className="section flagship" data-mood="latently">
      <div className="wrap">
        {/* .doorway is the room: one framed object (the mark's own edge
            grammar — three solid edges, one dashed top edge) holding the
            entire section on a warm, lit ground. See MeetLatently.css for
            why every text colour inside is overridden rather than left on
            the page's --ink/--mint tokens. */}
        <div className="doorway">
          <div className="flagship__grid">
            <div className="flagship__copy">
              <span className="livetag">
                <MintNest />
                Live · in alpha
              </span>
              <h2>Meet Latently.</h2>
              <p>
                Scientific papers are made for A4 paper, and most reading happens on a
                phone. Latently re-typesets any paper so it reads comfortably on the
                screen in your hand, equations and figures included.
              </p>
              <p>
                We designed it, built it, and run it. It is in iOS alpha with researchers
                right now.
              </p>
              <a className="btn" href="https://latently.app" target="_blank" rel="noopener noreferrer">
                Visit latently.app <Arrow />
              </a>
            </div>
            <RoomWindow
              src="/latently-shot.jpg"
              srcMobile="/latently-mobile.jpg"
              alt="Latently on a phone: a scientific paper re-typeset to fit the screen"
            />
            {/* Seam departure point for "latently-end": last child of
                .flagship__grid (position: relative, see MeetLatently.css), so
                it sits at the grid's own bottom-right corner below both
                columns, inside the room. RoomWindow no longer carries its
                own seam anchor. */}
          </div>
        </div>
      </div>
    </section>
  );
}
